// pig.batches.index - released feeder-batch hub
//
// PigBatchesView owns its six render reads through pig.batches.core. Its
// ppp-feeders-v1 mutations use local optimistic state plus saveAppStoreBlob;
// the scheduled maintenance owner derives webform mirrors from persisted
// source, so no App feeder context read or writer remains in this mount.

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'pig.batches.index',
  obligations: Object.freeze([Object.freeze({id: 'pig.batches.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
